import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Sparkles, RefreshCw, Image as ImageIcon } from "lucide-react";

export const AiFillPanel = ({ onDone }) => {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState("");

  const load = () =>
    api
      .get("/products/autofill-status")
      .then(({ data }) => setS(data))
      .catch(() => {});

  useEffect(() => {
    load();
  }, []);

  const run = async (payload, label, confirmMsg) => {
    if (confirmMsg && !window.confirm(confirmMsg)) return;
    setBusy(label);
    try {
      const { data } = await api.post("/products/autofill-missing", payload);
      toast.success(
        data.queued
          ? `${data.queued} produk sedang diproses AI di latar belakang. Muat ulang halaman ini beberapa menit lagi.`
          : "Semua produk sudah lengkap."
      );
      setTimeout(() => {
        load();
        onDone?.();
      }, 5000);
    } catch (e) {
      toast.error(errMsg(e, "Gagal memulai pengisian otomatis"));
    } finally {
      setBusy("");
    }
  };

  if (!s) return null;

  return (
    <div
      className="bg-white border border-gray-200 rounded-2xl p-5 space-y-4"
      data-testid="ai-fill-panel"
    >
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <p className="font-display font-semibold flex items-center gap-2">
            <Sparkles size={18} className="text-primary" /> Isi Otomatis dengan AI
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            {s.total} produk · <b data-testid="missing-photo-count">{s.missing_photo}</b> tanpa foto ·{" "}
            {s.missing_description} tanpa deskripsi · {s.missing_name_ja} tanpa nama Jepang
          </p>
        </div>
        <Button variant="ghost" size="icon" data-testid="ai-fill-refresh" onClick={load}>
          <RefreshCw size={16} />
        </Button>
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          data-testid="ai-fill-text-btn"
          disabled={busy === "text"}
          onClick={() =>
            run(
              { photo: false, description: true, description_ja: true, name_ja: true },
              "text",
              `Buat deskripsi (Indonesia + Jepang) dan nama Jepang untuk ${s.missing_description} produk? Ini memakai kredit AI teks (murah).`
            )
          }
        >
          <Sparkles size={15} className="mr-1" /> Deskripsi & nama Jepang
        </Button>
        <Button
          data-testid="ai-fill-photo-btn"
          disabled={busy === "photo" || !s.missing_photo}
          onClick={() =>
            run(
              { photo: true, description: true, description_ja: true, name_ja: true },
              "photo",
              `Buat foto AI untuk ${s.missing_photo} produk yang belum ada fotonya? Proses ini memakai kredit AI gambar dan berjalan sekitar ${Math.ceil(
                (s.missing_photo * 15) / 60
              )} menit di latar belakang.`
            )
          }
        >
          <ImageIcon size={15} className="mr-1" /> Foto + deskripsi ({s.missing_photo})
        </Button>
      </div>
      <p className="text-xs text-muted-foreground">
        Proses berjalan di latar belakang: Anda boleh menutup halaman. Klik tombol muat ulang di atas
        untuk melihat sisanya. Foto asli Anda tidak akan tertimpa.
      </p>
    </div>
  );
};
